var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 33,
    viewBox: "0 0 84 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.139946 21.4941H32.0547V27.0565H0.139946V21.4941Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6623 21.4937V8.84288C65.6623 8.13912 66.3272 7.4668 67.0283 7.4668H67.1178C67.142 7.4668 67.1637 7.47163 67.1879 7.47405L67.1952 7.4668H77.7778C79.3083 7.4668 79.903 8.56476 80.4567 9.37978C81.6317 11.109 82.8286 14.1151 82.8503 17.1913V17.1695L82.8721 27.0561H33.264V21.4937H65.6623Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.871 8.67578V14.6856C66.871 14.6856 71.0272 16.7388 81.8057 18.1778C81.8057 18.1778 81.6993 11.0942 78.1621 8.67578H66.8734H66.871Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5123 31.421C68.2462 31.421 66.4093 29.5836 66.4093 27.317C66.4093 25.0503 68.2462 23.2129 70.5123 23.2129C72.7783 23.2129 74.6152 25.0503 74.6152 27.317C74.6152 29.5836 72.7783 31.421 70.5123 31.421Z",
    fill: "#868686",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4452 29.982C68.9729 29.9455 67.8092 28.7219 67.8462 27.2492C67.8832 25.7764 69.1067 24.6121 70.5791 24.6487C72.0515 24.6852 73.2151 25.9088 73.1782 27.3815C73.1412 28.8543 71.9176 30.0186 70.4452 29.982Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.733 27.3178C69.733 27.7483 70.0811 28.0965 70.5115 28.0965C70.9419 28.0965 71.29 27.7483 71.29 27.3178C71.29 26.8873 70.9419 26.5391 70.5115 26.5391C70.0811 26.5391 69.733 26.8873 69.733 27.3178Z",
    fill: "#272727",
    stroke: "#868686",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6817 27.3174C35.6817 29.5835 37.5193 31.4239 39.7847 31.4239C42.0502 31.4239 43.8877 29.5859 43.8877 27.3174C43.8877 25.0489 42.0502 23.2109 39.7847 23.2109C37.5193 23.2109 35.6817 25.0489 35.6817 27.3174Z",
    fill: "#868686",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.12 27.3179C37.12 28.7907 38.3144 29.9854 39.7868 29.9854C41.2592 29.9854 42.4536 28.7907 42.4536 27.3179C42.4536 25.8451 41.2592 24.6504 39.7868 24.6504C38.3144 24.6504 37.12 25.8451 37.12 27.3179Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0089 27.3178C39.0089 27.7483 39.357 28.0965 39.7874 28.0965C40.2178 28.0965 40.5659 27.7483 40.5659 27.3178C40.5659 26.8873 40.2178 26.5391 39.7874 26.5391C39.357 26.5391 39.0089 26.8873 39.0089 27.3178Z",
    fill: "#272727",
    stroke: "#868686",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3361 27.3174C45.3361 29.5835 47.1736 31.4239 49.4415 31.4239C51.7093 31.4239 53.5444 29.5859 53.5444 27.3174C53.5444 25.0489 51.7069 23.2109 49.4415 23.2109C47.176 23.2109 45.3361 25.0489 45.3361 27.3174Z",
    fill: "#868686",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7748 27.3179C46.7748 28.7907 47.9692 29.9854 49.4416 29.9854C50.914 29.9854 52.1084 28.7907 52.1084 27.3179C52.1084 25.8451 50.914 24.6504 49.4416 24.6504C47.9692 24.6504 46.7748 25.8451 46.7748 27.3179Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6607 27.3178C48.6607 27.7483 49.0089 28.0965 49.4392 28.0965C49.8696 28.0965 50.2178 27.7483 50.2178 27.3178C50.2178 26.8873 49.8696 26.5391 49.4392 26.5391C49.0089 26.5391 48.6607 26.8873 48.6607 27.3178Z",
    fill: "#272727",
    stroke: "#868686",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15393 27.3174C2.15393 29.5835 3.99145 31.4239 6.25933 31.4239C8.52721 31.4239 10.3623 29.5859 10.3623 27.3174C10.3623 25.0489 8.52479 23.2109 6.25933 23.2109C3.99386 23.2109 2.15393 25.0489 2.15393 27.3174Z",
    fill: "#868686",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5902 27.3179C3.5902 28.7907 4.78458 29.9854 6.25701 29.9854C7.72944 29.9854 8.92383 28.7907 8.92383 27.3179C8.92383 25.8451 7.72944 24.6504 6.25701 24.6504C4.78458 24.6504 3.5902 25.8451 3.5902 27.3179Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47908 27.3178C5.47908 27.7483 5.82724 28.0965 6.25761 28.0965C6.68797 28.0965 7.03613 27.7483 7.03613 27.3178C7.03613 26.8873 6.68797 26.5391 6.25761 26.5391C5.82724 26.5391 5.47908 26.8873 5.47908 27.3178Z",
    fill: "#272727",
    stroke: "#868686",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8058 27.3174C11.8058 29.5835 13.6433 31.4239 15.9112 31.4239C18.1791 31.4239 20.0142 29.5859 20.0142 27.3174C20.0142 25.0489 18.1766 23.2109 15.9112 23.2109C13.6457 23.2109 11.8058 25.0489 11.8058 27.3174Z",
    fill: "#868686",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2445 27.3179C13.2445 28.7907 14.4389 29.9854 15.9113 29.9854C17.3837 29.9854 18.5781 28.7907 18.5781 27.3179C18.5781 25.8451 17.3837 24.6504 15.9113 24.6504C14.4389 24.6504 13.2445 25.8451 13.2445 27.3179Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 27.3178C15.1304 27.7483 15.4786 28.0965 15.909 28.0965C16.3393 28.0965 16.6875 27.7483 16.6875 27.3178C16.6875 26.8873 16.3393 26.5391 15.909 26.5391C15.4786 26.5391 15.1304 26.8873 15.1304 27.3178Z",
    fill: "#272727",
    stroke: "#868686",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3791 25.1211C80.0841 25.1211 79.8424 25.3097 79.8424 25.6048C79.8424 25.8998 80.0817 26.0885 80.3791 26.0885H81.4115C81.7065 26.0885 81.9482 25.8998 81.9482 25.6048C81.9482 25.3097 81.7089 25.1211 81.4115 25.1211H80.3791Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6564 25.1211C29.3615 25.1211 29.1197 25.3097 29.1197 25.6048C29.1197 25.8998 29.3591 26.0885 29.6564 26.0885H30.6888C30.9838 26.0885 31.2256 25.8998 31.2256 25.6048C31.2256 25.3097 30.9862 25.1211 30.6888 25.1211H29.6564Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28388 22.2207C0.988911 22.2207 0.747133 22.4093 0.747133 22.7044C0.747133 22.9994 0.986494 23.1881 1.28388 23.1881H2.31628C2.61125 23.1881 2.85303 22.9994 2.85303 22.7044C2.85303 22.4093 2.61367 22.2207 2.31628 22.2207H1.28388Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4651 8.43359H72.1904V16.4144H71.4651V8.43359Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4891 7.4668H63.0746C63.6694 7.4668 64.2109 8.06415 64.2109 8.65908V20.2845H33.2633V8.65908C33.2633 8.06657 33.8944 7.4668 34.4867 7.4668H34.4891Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.95957 7.4668H31.0489C31.6437 7.4668 32.0547 8.06415 32.0547 8.65908V20.2845H0.139946V8.65908C0.139946 8.06657 0.364796 7.4668 0.95957 7.4668Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8047 6.74105C78.8047 6.74105 77.5063 0.414438 65.7172 0.443459C65.7172 0.443459 65.386 5.07233 65.8986 5.95022C65.8986 5.95022 66.2927 6.74105 66.7762 6.74105H78.8047Z",
    fill: "#868686"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.5122,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 83.5122 0.443359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD1);
export default __webpack_public_path__ + "static/media/d1.0e0d0a06d0605766de50ff26c2e26f70.svg";
export { ForwardRef as ReactComponent };